export function insertItemToArray(src = [], item, index = src.length) {
  return [
    ...src.slice(0, index),
    item,
    ...src.slice(index),
  ];
}
